// @flow
import React, { Component } from "react"
import { Motion, spring, presets } from "react-motion"
import { compose } from "react-apollo"
import {
  Container,
  Modal,
  Content,
  Body,
  Header,
  PrimaryHeading,
  Fade
} from "../UI/Modal"
import { queries as kioskQueries } from "../Kiosks"
import { queries as userQueries } from "../Users"
import { queries as attractLoopQueries } from "../AttractLoops"
import { queries as slideQueries } from "../Slides"
import { PrimaryButton, SecondaryButton } from "../UI/Buttons"
import type { Match, Location, RouterHistory } from "react-router-dom"
import Loader from "../UI/Loader"

type ConfirmMatch = {
  ...Match,
  params: {
    action: "delete" | "update" | "create",
    id: string,
    parentId?: string,
    type: "kiosks" | "users" | "loops"
  }
}

type ConfirmLocation = {
  ...Location,
  state: {
    modal: boolean,
    message: string,
    successPath: ?string
  }
}

type Props = {
  match: ConfirmMatch,
  location: ConfirmLocation,
  history: RouterHistory,
  deleteKiosk: Function,
  deleteUser: Function,
  deleteAttractLoop: Function,
  deleteSlide: (attractLoopId: string, id: string) => any
}

type State = { isLoading: boolean }

class ConfirmModal extends Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { isLoading: false }
  }

  async mutate() {
    const {
      deleteKiosk,
      deleteUser,
      deleteAttractLoop,
      deleteSlide,
      match: { params: { type, action, id, parentId } }
    } = this.props
    switch (type) {
      case "kiosks":
        switch (action) {
          case "delete":
            await deleteKiosk(id)
            break
          default:
            break
        }
        break
      case "users":
        switch (action) {
          case "delete":
            await deleteUser(id)
            break
          default:
            break
        }
        break
      case "attract-loops":
        switch (action) {
          case "delete":
            await deleteAttractLoop(id)
            break
          default:
            break
        }
        break
      case "slides":
        switch (action) {
          case "delete":
            if (!parentId) {
              break
            }
            await deleteSlide(parentId, id)
            break
          default:
            break
        }
        break
      default:
        break
    }
  }

  async handleConfirm() {
    const { history, location: { state: { successPath } } } = this.props
    this.setState(() => ({ isLoading: true }))
    try {
      await this.mutate()
    } catch (error) {
      console.log(error)
      history.goBack()
      return
    }
    this.setState(() => ({ isLoading: false }))
    if (successPath) {
      history.replace(successPath)
    } else {
      history.goBack()
    }
  }

  handleCancel() {
    const { history } = this.props
    history.goBack()
  }

  render() {
    const { location: { state } } = this.props
    const { isLoading } = this.state
    return (
      <Container>
        <Fade onClick={() => this.handleCancel()} dark />
        <Modal>
          <Motion
            key="body"
            defaultStyle={{ y: -100, a: 0 }}
            style={{
              y: spring(0, presets.wobbly),
              a: spring(1, presets.noWobble)
            }}
          >
            {is => (
              <Body
                style={{
                  transform: `translate(0, ${is.y}px`,
                  opacity: is.a
                }}
              >
                <Loader loading={isLoading}>
                  <Header>
                    <PrimaryHeading>Are You Sure?</PrimaryHeading>
                  </Header>
                  <Content>
                    <p>{state ? state.message : "Are you sure?"}</p>
                    <SecondaryButton onClick={e => this.handleCancel()}>
                      Cancel
                    </SecondaryButton>
                    <PrimaryButton onClick={e => this.handleConfirm()}>
                      Confirm
                    </PrimaryButton>
                  </Content>
                </Loader>
              </Body>
            )}
          </Motion>
        </Modal>
      </Container>
    )
  }
}

const withMutations = compose(
  kioskQueries.mutateDeleteKiosk,
  userQueries.mutateDeleteUser,
  attractLoopQueries.mutateDeleteAttractLoop,
  slideQueries.mutateDeleteSlide
)

export default withMutations(ConfirmModal)



// WEBPACK FOOTER //
// ./src/Admin/ConfirmModal.js